"use client";

import { useEffect } from "react";
import { IconScale, IconRefresh } from "@tabler/icons-react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[LawChat Global Error]", error);
    try {
      fetch("/api/antigravity-chat/report-error", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          errorType: "Next.js Global Root Layout Error",
          errorMessage: error?.message || "Eroare critică în layout-ul rădăcină",
          stackTrace: error?.stack || error?.digest || null,
        }),
      }).catch(() => {});
    } catch {}
  }, [error]);

  return (
    <html lang="ro">
      <body className="min-h-screen bg-[#F8F5F1] text-[#2C1810] flex flex-col items-center justify-center p-4 m-0 font-sans">
        <div className="w-full max-w-lg bg-white border border-[#E8DFD8] rounded-2xl shadow-xl p-8 text-center relative overflow-hidden">
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#C4622D] via-[#D97706] to-[#C4622D]" />

          <div className="inline-flex items-center gap-2.5 mb-6">
            <div className="w-11 h-11 rounded-xl bg-[#FBF0EA] flex items-center justify-center text-[#C4622D]">
              <IconScale className="size-6" />
            </div>
            <span className="text-xl font-bold tracking-tight text-[#2C1810]">
              LawChat
            </span>
            <span className="text-[11px] font-semibold bg-[#C4622D] text-white px-2 py-0.5 rounded-md uppercase tracking-wider">
              Pro
            </span>
          </div>

          <div className="inline-flex items-center gap-2 bg-[#FEF3C7] text-[#92400E] text-xs font-semibold px-3.5 py-1.5 rounded-full mb-5">
            <span className="h-2 w-2 rounded-full bg-[#D97706]" />
            <span>Actualizare sau Mentenanță Temporară</span>
          </div>

          <h1 className="text-2xl font-bold text-[#2C1810] mb-3">
            Serviciul este temporar indisponibil
          </h1>

          <p className="text-sm text-[#6B5E57] mb-6 leading-relaxed">
            Platforma întâmpină o scurtă indisponibilitate tehnică. Echipa noastră lucrează la restabilirea imediată a serviciilor.
          </p>

          <div className="flex justify-center">
            <button
              onClick={() => reset()}
              className="inline-flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl bg-[#C4622D] hover:bg-[#A0501F] text-white text-sm font-semibold shadow-sm transition-all cursor-pointer"
            >
              <IconRefresh className="size-4" />
              Reîncearcă acum
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
